
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TriagingScalarFieldEnum = {
  id: 'id',
  title: 'title',
  version: 'version',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WellbeingProfileScalarFieldEnum = {
  id: 'id',
  version: 'version',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SurveyScalarFieldEnum = {
  id: 'id',
  title: 'title',
  version: 'version',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SurveySubmissionScalarFieldEnum = {
  id: 'id',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  completedAt: 'completedAt',
  notifiedAt: 'notifiedAt',
  surveyId: 'surveyId',
  answers: 'answers'
};

exports.Prisma.TriagingSubmissionScalarFieldEnum = {
  id: 'id',
  triagingId: 'triagingId',
  wellbeingProfileId: 'wellbeingProfileId',
  userId: 'userId',
  therapyId: 'therapyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  completedMatchingQuestionnaireAt: 'completedMatchingQuestionnaireAt',
  topics: 'topics',
  goalText: 'goalText',
  matchingNotes: 'matchingNotes',
  warningCallouts: 'warningCallouts',
  status: 'status',
  preferredModality: 'preferredModality',
  preferredCareType: 'preferredCareType',
  pendingMatchNote: 'pendingMatchNote',
  riskLevel: 'riskLevel',
  isRiskWellbeingCheckinBooked: 'isRiskWellbeingCheckinBooked',
  riskWellbeingCheckinBookedAt: 'riskWellbeingCheckinBookedAt',
  diagnosisId: 'diagnosisId',
  containsPillarResponses: 'containsPillarResponses',
  aboveCaseness: 'aboveCaseness',
  wellbeingScore: 'wellbeingScore',
  focusArea: 'focusArea',
  recommendedCareType: 'recommendedCareType'
};

exports.Prisma.DiagnosisScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  submissionId: 'submissionId',
  primaryProblems: 'primaryProblems',
  secondaryProblems: 'secondaryProblems',
  severity: 'severity',
  modality: 'modality',
  careType: 'careType'
};

exports.Prisma.OrganisationReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastGeneratedAt: 'lastGeneratedAt',
  organisationId: 'organisationId'
};

exports.Prisma.ProfessionalAvailabilityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  professionalId: 'professionalId',
  availableSlots: 'availableSlots'
};

exports.Prisma.ProfessionalAvailabilityRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  importDate: 'importDate',
  professionalId: 'professionalId',
  availabilityRuleId: 'availabilityRuleId',
  calendarIds: 'calendarIds',
  timezone: 'timezone',
  originalTimezone: 'originalTimezone'
};

exports.Prisma.ProfessionalEventScalarFieldEnum = {
  id: 'id',
  importedAt: 'importedAt',
  professionalId: 'professionalId',
  eventId: 'eventId',
  startTime: 'startTime',
  endTime: 'endTime',
  isExternalEvent: 'isExternalEvent'
};

exports.Prisma.TestUserScalarFieldEnum = {
  id: 'id',
  available: 'available',
  email: 'email',
  password: 'password',
  role: 'role',
  userId: 'userId'
};

exports.Prisma.ProfessionalAvailabilitySettingsHistoryScalarFieldEnum = {
  id: 'id',
  professionalId: 'professionalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AutomatedMatchingResultScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  submissionId: 'submissionId',
  diagnosisId: 'diagnosisId',
  variantShowMatchesFromSource: 'variantShowMatchesFromSource'
};

exports.Prisma.RiskAssessmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  targetUserId: 'targetUserId',
  currentTherapyId: 'currentTherapyId',
  riskLevel: 'riskLevel',
  conclusion: 'conclusion',
  submissionId: 'submissionId'
};

exports.Prisma.ChatMessageSentHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  therapyId: 'therapyId'
};

exports.Prisma.ScheduledEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  scheduledFor: 'scheduledFor',
  uniqueEventId: 'uniqueEventId',
  status: 'status'
};

exports.Prisma.ScheduledEventTTLScalarFieldEnum = {
  id: 'id',
  scheduledFor: 'scheduledFor'
};

exports.Prisma.CarePlanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  therapyId: 'therapyId',
  modalities: 'modalities',
  presentingProblem: 'presentingProblem',
  goals: 'goals',
  treatmentPlans: 'treatmentPlans',
  notes: 'notes',
  sessionsRemaining: 'sessionsRemaining',
  sessionsRemainingUpdatedAt: 'sessionsRemainingUpdatedAt',
  supervisionBooked: 'supervisionBooked'
};

exports.Prisma.SessionTranscriptScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  transcript: 'transcript',
  jsonTranscript: 'jsonTranscript',
  jsonTranscriptFile: 'jsonTranscriptFile',
  jsonTranscriptOrigin: 'jsonTranscriptOrigin'
};

exports.Prisma.SessionSummaryScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rawSessionSummary: 'rawSessionSummary',
  rating: 'rating',
  feedbackNotes: 'feedbackNotes',
  sessionTranscriptId: 'sessionTranscriptId',
  type: 'type'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};
exports.SurveyTitles = exports.$Enums.SurveyTitles = {
  CHECK_IN: 'CHECK_IN',
  RISK_ASSESSMENT: 'RISK_ASSESSMENT',
  PROGRESS_CHECK_PHQ2_GAD2: 'PROGRESS_CHECK_PHQ2_GAD2',
  PROGRESS_CHECK_PHQ9_GAD7: 'PROGRESS_CHECK_PHQ9_GAD7',
  PROGRESS_CHECK_THERAPY_BELOW_CASENESS: 'PROGRESS_CHECK_THERAPY_BELOW_CASENESS',
  PROFESSIONAL_NPS: 'PROFESSIONAL_NPS',
  CAREER_COACHING_PROGRESS: 'CAREER_COACHING_PROGRESS',
  EMPLOYEE_UNSATISFIED_WITH_PROFESSIONAL: 'EMPLOYEE_UNSATISFIED_WITH_PROFESSIONAL',
  EMPLOYEE_NPS: 'EMPLOYEE_NPS',
  TRIAL_GETTING_STARTED: 'TRIAL_GETTING_STARTED',
  TRIAL_FOLLOW_UP: 'TRIAL_FOLLOW_UP',
  SYMPTOMS_TRACKER: 'SYMPTOMS_TRACKER',
  POST_SESSION_SATISFACTION: 'POST_SESSION_SATISFACTION'
};

exports.SurveyStatus = exports.$Enums.SurveyStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED'
};

exports.SubmissionStatus = exports.$Enums.SubmissionStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  DELETED: 'DELETED',
  NEEDS_MATCHING: 'NEEDS_MATCHING',
  GENERATING_MATCH_OPTIONS: 'GENERATING_MATCH_OPTIONS',
  CHOOSING_MATCH: 'CHOOSING_MATCH',
  MATCHED: 'MATCHED',
  LIFE_RISK: 'LIFE_RISK'
};

exports.CareType = exports.$Enums.CareType = {
  THERAPEUTIC_STRUCTURED: 'THERAPEUTIC_STRUCTURED',
  THERAPEUTIC_UNSTRUCTURED: 'THERAPEUTIC_UNSTRUCTURED',
  COACHING: 'COACHING',
  CAREER_COACHING: 'CAREER_COACHING',
  HYBRID_CARE: 'HYBRID_CARE'
};

exports.MatchingResultVariantShowFromSource = exports.$Enums.MatchingResultVariantShowFromSource = {
  RULE_BASED: 'RULE_BASED',
  ML_ENGINE: 'ML_ENGINE'
};

exports.ScheduledEventStatus = exports.$Enums.ScheduledEventStatus = {
  PENDING: 'PENDING',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED'
};

exports.SessionsRemaining = exports.$Enums.SessionsRemaining = {
  TWO_OR_LESS: 'TWO_OR_LESS',
  MORE_THAN_TWO: 'MORE_THAN_TWO',
  UNSURE: 'UNSURE'
};

exports.SessionTranscriptStatus = exports.$Enums.SessionTranscriptStatus = {
  FETCHING: 'FETCHING',
  FETCHING_ERROR: 'FETCHING_ERROR',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  PROCESSED_WITH_ERRORS: 'PROCESSED_WITH_ERRORS'
};

exports.JsonTranscriptOrigin = exports.$Enums.JsonTranscriptOrigin = {
  DAILY: 'DAILY',
  OLIVA: 'OLIVA'
};

exports.SessionSummaryRating = exports.$Enums.SessionSummaryRating = {
  THUMBS_UP: 'THUMBS_UP',
  THUMBS_DOWN: 'THUMBS_DOWN'
};

exports.SessionSummaryType = exports.$Enums.SessionSummaryType = {
  EMPLOYEE: 'EMPLOYEE',
  PROFESSIONAL: 'PROFESSIONAL'
};

exports.TriagingBlockSection = exports.$Enums.TriagingBlockSection = {
  FINANCIAL: 'FINANCIAL',
  EMOTIONAL: 'EMOTIONAL',
  SOCIAL: 'SOCIAL',
  PROFESSIONAL: 'PROFESSIONAL',
  PHYSICAL: 'PHYSICAL',
  REFINEMENT_GAD7: 'REFINEMENT_GAD7',
  REFINEMENT_PHQ9: 'REFINEMENT_PHQ9',
  REFINEMENT_OCD_PTSD: 'REFINEMENT_OCD_PTSD',
  REFINEMENT_LIFE_RISK: 'REFINEMENT_LIFE_RISK',
  REFINEMENT_LIFE_RISK_TEXT: 'REFINEMENT_LIFE_RISK_TEXT',
  THERAPY_HISTORY: 'THERAPY_HISTORY',
  THERAPY_PREFERENCES: 'THERAPY_PREFERENCES',
  PROFESSIONAL_COACHING_GOALS: 'PROFESSIONAL_COACHING_GOALS',
  GAD2_PHQ2_QUESTIONNAIRE: 'GAD2_PHQ2_QUESTIONNAIRE',
  THERAPY_GOALS: 'THERAPY_GOALS'
};

exports.WellbeingProfileSection = exports.$Enums.WellbeingProfileSection = {
  EMOTIONAL: 'EMOTIONAL',
  SLEEP: 'SLEEP',
  PHYSICAL: 'PHYSICAL',
  PROFESSIONAL: 'PROFESSIONAL',
  FINANCIAL: 'FINANCIAL',
  IMPACT: 'IMPACT'
};

exports.QuestionType = exports.$Enums.QuestionType = {
  TEXT: 'TEXT',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  MULTIPLE_CHOICES: 'MULTIPLE_CHOICES',
  TOPICS: 'TOPICS',
  HEADER: 'HEADER'
};

exports.DayOfWeek = exports.$Enums.DayOfWeek = {
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sunday: 'sunday'
};

exports.ChatMessageType = exports.$Enums.ChatMessageType = {
  MESG: 'MESG',
  FILE: 'FILE',
  ADMM: 'ADMM'
};

exports.TherapyPreferredTime = exports.$Enums.TherapyPreferredTime = {
  MORNINGS: 'MORNINGS',
  AFTERNOONS: 'AFTERNOONS',
  EVENINGS: 'EVENINGS',
  ANYTIME: 'ANYTIME'
};

exports.MentalHealthTopics = exports.$Enums.MentalHealthTopics = {
  ADJUSTMENT_DISORDER: 'ADJUSTMENT_DISORDER',
  ANGER: 'ANGER',
  ANXIETY: 'ANXIETY',
  ATTENTION_AND_HYPERACTIVITY_CONCERNS: 'ATTENTION_AND_HYPERACTIVITY_CONCERNS',
  BEREAVEMENT_REACTION: 'BEREAVEMENT_REACTION',
  BI_POLAR_DEPRESSION: 'BI_POLAR_DEPRESSION',
  BODY_DYSMORPHIA: 'BODY_DYSMORPHIA',
  BREAKING_HABITS: 'BREAKING_HABITS',
  CULTURAL_IDENTITY: 'CULTURAL_IDENTITY',
  DEPRESSION: 'DEPRESSION',
  FEELING_DEPRESSED_LOW_MOOD: 'FEELING_DEPRESSED_LOW_MOOD',
  FINDING_PURPOSE: 'FINDING_PURPOSE',
  GAMBLING_NON_SUBSTANCE_ADDICTIONS: 'GAMBLING_NON_SUBSTANCE_ADDICTIONS',
  GENERALIZED_ANXIETY_DISORDER: 'GENERALIZED_ANXIETY_DISORDER',
  GRIEF_LOSS: 'GRIEF_LOSS',
  INDECISION: 'INDECISION',
  LACK_OF_CONFIDENCE: 'LACK_OF_CONFIDENCE',
  OBSESSIONS_AND_COMPULSIONS: 'OBSESSIONS_AND_COMPULSIONS',
  OCD: 'OCD',
  PANIC_DISORDER_WITH_AGORAPHOBIA: 'PANIC_DISORDER_WITH_AGORAPHOBIA',
  PANIC_DISORDER_WITHOUT_AGORAPHOBIA: 'PANIC_DISORDER_WITHOUT_AGORAPHOBIA',
  PERFECTIONISM: 'PERFECTIONISM',
  PHOBIAS: 'PHOBIAS',
  PROCRASTINATION: 'PROCRASTINATION',
  PTSD: 'PTSD',
  RUMINATION: 'RUMINATION',
  SELF_ESTEEM: 'SELF_ESTEEM',
  SERIOUS_MENTAL_ILLNESS: 'SERIOUS_MENTAL_ILLNESS',
  SIGNIFICANT_OR_CHRONIC_STRESS: 'SIGNIFICANT_OR_CHRONIC_STRESS',
  SKIN_PICKING: 'SKIN_PICKING',
  SUBSTANCE_ALCOHOL_USE_CONCERNS: 'SUBSTANCE_ALCOHOL_USE_CONCERNS',
  TRAUMA: 'TRAUMA',
  TRICHOTILLOMANIA: 'TRICHOTILLOMANIA',
  WORRY_ABOUT_BURNOUT: 'WORRY_ABOUT_BURNOUT',
  WORRY_ABOUT_PERFORMANCE_AT_WORK: 'WORRY_ABOUT_PERFORMANCE_AT_WORK',
  UNHAPPY_AT_WORK: 'UNHAPPY_AT_WORK',
  HELP_WITH_ADOPTING_HEALTHIER_HABITS: 'HELP_WITH_ADOPTING_HEALTHIER_HABITS',
  BEING_A_MANAGER_FOR_THE_FIRST_TIME: 'BEING_A_MANAGER_FOR_THE_FIRST_TIME',
  BEING_A_MANAGER_ISSUES: 'BEING_A_MANAGER_ISSUES',
  BEING_PROMOTED: 'BEING_PROMOTED',
  BURNOUT: 'BURNOUT',
  CAREER_CHANGE: 'CAREER_CHANGE',
  COMMUNICATION_ISSUES_AT_WORK: 'COMMUNICATION_ISSUES_AT_WORK',
  DEALING_WITH_UNCERTAINTY_AT_WORK: 'DEALING_WITH_UNCERTAINTY_AT_WORK',
  DECISION_MAKING: 'DECISION_MAKING',
  DIVERSITY_EQUITY_INCLUSION_AT_WORK: 'DIVERSITY_EQUITY_INCLUSION_AT_WORK',
  GIVING_RECEIVING_FEEDBACK: 'GIVING_RECEIVING_FEEDBACK',
  IMPOSTER_SYNDROME: 'IMPOSTER_SYNDROME',
  INTERPERSONAL_ISSUES: 'INTERPERSONAL_ISSUES',
  RECENT_PROMOTION: 'RECENT_PROMOTION',
  REMOTE_WORK_ISSUES: 'REMOTE_WORK_ISSUES',
  STRESS_AND_WORRY_AT_WORK: 'STRESS_AND_WORRY_AT_WORK',
  WORK_LIFE_BALANCE: 'WORK_LIFE_BALANCE',
  HELP_WITH_WORK_RELATED_ISSUE: 'HELP_WITH_WORK_RELATED_ISSUE',
  CHRONIC_PAIN: 'CHRONIC_PAIN',
  EATING_WEIGHT_ISSUES: 'EATING_WEIGHT_ISSUES',
  HEALTH_ANXIETY: 'HEALTH_ANXIETY',
  INSOMNIA: 'INSOMNIA',
  LACK_OF_EXERCISE: 'LACK_OF_EXERCISE',
  LONG_TERM_HEALTH_CONDITION: 'LONG_TERM_HEALTH_CONDITION',
  MEDICALLY_UNEXPLAINED_SYMPTOMS: 'MEDICALLY_UNEXPLAINED_SYMPTOMS',
  MINDFULNESS_MEDITATION: 'MINDFULNESS_MEDITATION',
  QUITTING_SMOKING: 'QUITTING_SMOKING',
  SLEEP_ISSUES: 'SLEEP_ISSUES',
  ASSERTIVENESS: 'ASSERTIVENESS',
  BEING_A_CARER: 'BEING_A_CARER',
  BUILDING_NEW_RELATIONSHIPS: 'BUILDING_NEW_RELATIONSHIPS',
  BULLYING: 'BULLYING',
  DIVERSITY_EQUITY_INCLUSION: 'DIVERSITY_EQUITY_INCLUSION',
  IMPROVING_MY_RELATIONSHIPS: 'IMPROVING_MY_RELATIONSHIPS',
  MANAGING_CONFLICT: 'MANAGING_CONFLICT',
  NAVIGATING_CONFLICT: 'NAVIGATING_CONFLICT',
  PARENTING_CAREGIVING_FAMILY: 'PARENTING_CAREGIVING_FAMILY',
  SEXUAL_DYSFUNCTION: 'SEXUAL_DYSFUNCTION',
  SOCIAL_ANXIETY: 'SOCIAL_ANXIETY',
  SPEAKING_IN_FRONT_OF_OTHERS: 'SPEAKING_IN_FRONT_OF_OTHERS',
  COMPULSIVE_BUYING: 'COMPULSIVE_BUYING',
  DEALING_WITH_DEBT: 'DEALING_WITH_DEBT',
  DEALING_WITH_FINANCIAL_WORRY: 'DEALING_WITH_FINANCIAL_WORRY',
  FINANCIAL_ANXIETY: 'FINANCIAL_ANXIETY',
  FINANCIAL_STABILITY: 'FINANCIAL_STABILITY',
  FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS: 'FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS',
  OVERALL_WELLNESS: 'OVERALL_WELLNESS'
};

exports.MentalHealthPillars = exports.$Enums.MentalHealthPillars = {
  EMOTIONAL: 'EMOTIONAL',
  PROFESSIONAL: 'PROFESSIONAL',
  PHYSICAL: 'PHYSICAL',
  SOCIAL: 'SOCIAL',
  FINANCIAL: 'FINANCIAL'
};

exports.Prisma.ModelName = {
  triaging: 'triaging',
  wellbeingProfile: 'wellbeingProfile',
  survey: 'survey',
  surveySubmission: 'surveySubmission',
  triagingSubmission: 'triagingSubmission',
  diagnosis: 'diagnosis',
  organisationReport: 'organisationReport',
  professionalAvailability: 'professionalAvailability',
  professionalAvailabilityRule: 'professionalAvailabilityRule',
  professionalEvent: 'professionalEvent',
  testUser: 'testUser',
  professionalAvailabilitySettingsHistory: 'professionalAvailabilitySettingsHistory',
  automatedMatchingResult: 'automatedMatchingResult',
  riskAssessment: 'riskAssessment',
  chatMessageSentHistory: 'chatMessageSentHistory',
  scheduledEvent: 'scheduledEvent',
  scheduledEventTTL: 'scheduledEventTTL',
  carePlan: 'carePlan',
  sessionTranscript: 'sessionTranscript',
  sessionSummary: 'sessionSummary'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
